var ARTICLEACCESSLEVEL = {
  ALL: 0,
  LOGGEDIN: 1,
  MEMBERS: 2
};

module.exports = ARTICLEACCESSLEVEL;
